const { kakao } = window;

function KakaoMapScript() {
  const container = document.getElementById("myMap");
  const options = {
    center: new kakao.maps.LatLng(37.4792117, 126.9508357),
    level: 3,
  };
  const map = new kakao.maps.Map(container, options);

  var markerPosition = new kakao.maps.LatLng(37.4792117, 126.9508357);

  //마커생성
  var marker = new kakao.maps.Marker({
    position: markerPosition,
  });

  marker.setMap(map);
}

export default KakaoMapScript;
